import { useAuth } from '@/lib/auth/auth';
import { dashboardKeys, followingFeedKeys, nearbyFeedKeys } from '@/features/events/feed/feedQuery';
import { editableEventKeys } from '@/features/events/useEditableEvent';
import { eventDetailKeys } from '@/features/events/useEventDetail';
import { notificationKeys } from '@/features/pulse/useNotifications';
import { venueOwnerOverviewKeys } from '@/features/venues/useVenueOwnerOverview';
import { venueEventKeys } from '@/features/venues/useVenueEvents';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteEvent() {
  const request = useAuth((state) => state.request);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ eventID }: { eventID: string; venueID?: string | null }) =>
      request<void>(`/events/${eventID}`, {
        method: 'DELETE',
      }),
    onSuccess: async (_data, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: eventDetailKeys.byId(variables.eventID) }),
        queryClient.invalidateQueries({ queryKey: nearbyFeedKeys.all }),
        queryClient.invalidateQueries({ queryKey: followingFeedKeys.all }),
        queryClient.invalidateQueries({ queryKey: dashboardKeys.current() }),
        queryClient.invalidateQueries({ queryKey: editableEventKeys.all }),
        queryClient.invalidateQueries({ queryKey: notificationKeys.all }),
        variables.venueID
          ? queryClient.invalidateQueries({ queryKey: venueEventKeys.list(variables.venueID) })
          : Promise.resolve(),
        variables.venueID
          ? queryClient.invalidateQueries({ queryKey: venueOwnerOverviewKeys.detail(variables.venueID) })
          : Promise.resolve(),
      ]);
    },
  });
}
